import React, {Component} from 'react';
import {Label, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {request} from "../../../helper/APIUtils";
import {deepCopyObject, showAxiosError, toFixedNumber} from "../../../helper/helper";
import moment from "moment";
import Alert from "react-s-alert";
import {validateComponent, validateField} from "../../../common/validation";
import {Decimal} from "decimal.js";
import CustomerPriceListItems from "./CustomerPriceListItems";
import DistributorPriceList from "./DistributorPriceList";
import NumberFormat from "react-number-format";
import {EntegratorConf} from "../../../constants";
import {defterUnitName, showConnectorPayment} from "../../../helper/permission";
import NewCustomaryPriceListItems from "./NewCustomaryPriceListItems";

class CustomerPriceListModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            listPrices: [],
            listPriceMbs: [],
            customerCntFactor:[],
            isLoading:false,
            error:{},
            activeTab: "priceList",
            listPriceItem:{
                recordId:null,
                ownerCustomerId:null,
                startDate:null,
                finishDate: null,
                lowerLimit: null,
                upperLimit:null,
                priceCash:null,
                priceInSixInstallments:null,
                priceInNineInstallments: null,
                unitPrice:0.00,
                factor:1.00,
            },
            defaultCustomerCntFactorMap:[
                {id:1,lowerLimit:0,upperLimit:100},
            ],
            creditsYears:[{
                customerId:this.props.customer.recordId,
                unit:1,
                expireYear:2
            },{
                customerId: this.props.customer.recordId,
                unit:2,
                expireYear:1
            }],
            installationPriceList: {
                recordId:null,
                connectorType:null,
                serviceType:null,
                servicePrice:0.00,
                progressRate:0,
                startDate: null,
                expireDate: null
            },
            usedDefaultListPrices: false,
            usedDefaultInstallationPrices: false,
            usedDefaultListPricesMb: false,
            erpTypes:[],
            serviceTypes:[]
        };

        this.closeCustomerPriceListModal = this.closeCustomerPriceListModal.bind(this);
        this.fetchPriceList = this.fetchPriceList.bind(this);
        this.validateClass =  this.validateClass.bind(this);
        this.validateField =  this.validateField.bind(this);
        this.validateMessage =  this.validateMessage.bind(this);
        this.validateComponent =  this.validateComponent.bind(this);
        this.checkDateValidity =  this.checkDateValidity.bind(this);
        this.handleEditDates = this.handleEditDates.bind(this);
        this.save = this.save.bind(this);
        this.onChangePrice = this.onChangePrice.bind(this);
        this.onChange = this.onChange.bind(this);
        this.checkRangeOverLaps = this.checkRangeOverLaps.bind(this);
        this.handleRemove = this.handleRemove.bind(this);
        this.addNewLine = this.addNewLine.bind(this);
        this.fetchPriceListMb = this.fetchPriceListMb.bind(this);
        this.toggle = this.toggle.bind(this);
        this.checkRanges = this.checkRanges.bind(this);
        this.updateFactor = this.updateFactor.bind(this);
        this.fetchCustomerCntFactor = this.fetchCustomerCntFactor.bind(this);
        this.fetchCreditYears = this.fetchCreditYears.bind(this);
        this.onChangeNumber = this.onChangeNumber.bind(this);
        this.listPriceRef = React.createRef();
        this.listPriceMbRef = React.createRef();
        this.customerCntFactorRef = React.createRef();
        this.installationPriceRef = React.createRef();
        this.getErpTypes = this.getErpTypes.bind(this);
        this.getServiceTypes = this.getServiceTypes.bind(this);
    }

    async componentDidMount() {
        let self = this;
        let listPrices=[];
        let listPriceMbs=[];
        let creditsYears=[];
        let customerCntFactor=[];
        let installationPriceList = [];
        let usedDefaultListPrices = deepCopyObject(this.state.usedDefaultListPrices);
        let usedDefaultInstallationPrices = deepCopyObject(this.state.usedDefaultInstallationPrices);
        let usedDefaultListPricesMb = deepCopyObject(this.state.usedDefaultListPricesMb);

        await self.getErpTypes();
        await self.getServiceTypes();
        listPrices = await self.fetchPriceList();
        listPriceMbs= await self.fetchPriceListMb();
        customerCntFactor= await self.fetchCustomerCntFactor();
        creditsYears = await  self.fetchCreditYears();
        if(showConnectorPayment(EntegratorConf.identifier)){
            installationPriceList = await self.fetchInstallationPrices();
        }

        if( Array.isArray(listPrices) && listPrices.length > 0 && listPrices[0].recordId == null){
            usedDefaultListPrices = true;
        }
        if( Array.isArray(listPriceMbs) && listPriceMbs.length > 0 && listPriceMbs[0].recordId == null){
            usedDefaultListPricesMb = true;
        }
        if( Array.isArray(installationPriceList) && installationPriceList.length > 0 && installationPriceList[0].recordId == null){
            usedDefaultInstallationPrices = true;
        }

        if (creditsYears.length === 0) {
            creditsYears.push({
                    customerId: this.props.customer.recordId,
                    unit: 1,
                    expireYear: 2
                }, {
                    customerId: this.props.customer.recordId,
                    unit: 2,
                    expireYear: 1
                },
            );
        }
        this.setState({listPrices,listPriceMbs,customerCntFactor, installationPriceList, usedDefaultListPricesMb, usedDefaultInstallationPrices, usedDefaultListPrices, creditsYears});
    }

    async getErpTypes() {
        let erpTypes = [];
        let params = {
            url: '/connector/fetchErpTypes/',
            method: "get",
        };
        request(params).then(response => {
                response.data.map(data => {
                    erpTypes.push({value: data[0], label: data[1]});
                });
            this.setState({erpTypes});
        }).catch(error => {
            showAxiosError(error);
        });
    }

    async getServiceTypes() {
        let serviceTypes = [];
        let params = {
            url: '/connector/fetchServiceTypes/',
            method: "get",
        };
        request(params).then(response => {
            response.data.map(data => {
                serviceTypes.push({value: data[0], label: data[1]});
            });
            this.setState({serviceTypes});
        }).catch(error => {
            showAxiosError(error);
        });
    }

    validateField(e) {
        let id = e.target.id;
        let rule = e.target.dataset.vdata;
        let boundary = e.target.dataset.vlength && e.target.dataset.vlength;
        let value = e.target.value;
        let result = validateField(rule, boundary, value);
        let error = this.state.error;
        error = Object.assign(error, {[id]: result});
        this.setState({error});
    }

    validateClass(id) {
        let error = this.state.error;
        return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
    }

    validateMessage(id) {
        let error = this.state.error;
        return (error[id] === undefined ? '' : (error[id].message));
    }

    validateComponent() {
        let result = validateComponent(this);
        this.setState({
            error: result.error
        });
        return result
    }

    checkDateValidity(index,current, name,key) {
        let listPrices = deepCopyObject(this.state.listPrices);
        let listPriceMbs = deepCopyObject(this.state.listPriceMbs);

        if(key==="listPrices"){
            let copyCurrent = current.clone();
            if (name === 'startDate') {
                return moment(copyCurrent).isValid;
            }
            if (name === 'finishDate') {
                return copyCurrent.isAfter(listPrices[index].startDate);
            }
        }else if (key==="listPriceMbs"){
            let copyCurrent = current.clone();
            if (name === 'startDate') {
                return moment(copyCurrent).isValid;
            }
            if (name === 'finishDate') {
                return copyCurrent.isAfter(listPriceMbs[index].startDate);
            }
        }
    }

    handleEditDates(index, event, type,key) {
        let listPrices = deepCopyObject(this.state.listPrices);
        let listPriceMbs = deepCopyObject(this.state.listPriceMbs);
        let customerCntFactor = deepCopyObject(this.state.customerCntFactor);
        let installationPriceList = deepCopyObject(this.state.installationPriceList);

        if(key==="listPrices") {
            if (type === 'startDate') {
                if (!(typeof event === "string")) {
                    let startDate = event.format("YYYY-MM-DD");
                    let finishDate = event.clone().add(1, 'years').format('YYYY-MM-DD');

                    listPrices[index].startDate = startDate;
                    listPrices[index].finishDate = finishDate;
                    this.setState({listPrices});
                }
            } else {
                if (!(typeof selection === "string")) {
                    let finishDate = event.format("YYYY-MM-DD");
                    listPrices[index].finishDate = finishDate;
                    this.setState({listPrices});
                }
            }
        } else if(key==="listPriceMbs"){
            if (type === 'startDate') {
                if (!(typeof event === "string")) {
                    let startDate = event.format("YYYY-MM-DD");
                    let finishDate = event.clone().add(1, 'years').format('YYYY-MM-DD');

                    listPriceMbs[index].startDate = startDate;
                    listPriceMbs[index].finishDate = finishDate;
                    this.setState({listPriceMbs});
                }
            } else {
                if (!(typeof selection === "string")) {
                    let finishDate = event.format("YYYY-MM-DD");
                    listPriceMbs[index].finishDate = finishDate;
                    this.setState({listPriceMbs});
                }
            }
        } else if(key==="customerCntFactor"){
            if (type === 'startDate') {
                if (!(typeof event === "string")) {
                    let startDate = event.format("YYYY-MM-DD");
                    let finishDate = event.clone().add(1, 'years').format('YYYY-MM-DD');

                    customerCntFactor[index].startDate = startDate;
                    customerCntFactor[index].finishDate = finishDate;
                    this.setState({customerCntFactor});
                }
            } else {
                if (!(typeof selection === "string")) {
                    let finishDate = event.format("YYYY-MM-DD");
                    customerCntFactor[index].finishDate = finishDate;
                    this.setState({customerCntFactor});
                }
            }
        }
        else if(key==="installationPriceList"){
            if (type === 'startDate') {
                if (!(typeof event === "string")) {
                    let startDate = event.format("YYYY-MM-DD");
                    let expireDate = event.clone().add(1, 'years').format('YYYY-MM-DD');

                    installationPriceList[index].startDate = startDate;
                    installationPriceList[index].expireDate = expireDate;
                    this.setState({installationPriceList});
                }
            } else {
                if (!(typeof selection === "string")) {
                    let expireDate = event.format("YYYY-MM-DD");
                    installationPriceList[index].expireDate = expireDate;
                    this.setState({installationPriceList});
                }
            }
        }
    }

    async fetchPriceList() {
        let self = this;
        let url =  '/list-price/customer/'+this.props.customer.recordId ;
        let listPrices = [];
        let params = {
            url: url,
            method: "get",
        };
        self.setState({isLoading: true});
        return request(params)
            .then(function (response) {
                let listPrices=response.data;
                for(let i=0;i<listPrices.length;i++){
                    listPrices[i]["startDate"] = moment(listPrices[i]["startDate"]).format("YYYY-MM-DD");
                    listPrices[i]["finishDate"] = moment(listPrices[i]["finishDate"]).format("YYYY-MM-DD");
                }
                self.setState({
                    isLoading: false,
                });
                return Promise.resolve(response.data);
            }).catch(function (error) {
                showAxiosError(error);
                self.setState({ isLoading: false})
                return Promise.resolve(listPrices);
            });
    }

    async fetchPriceListMb() {
        let self = this;
        let url =  '/list-price/mb/customer/'+this.props.customer.recordId;
        let listPriceMbs = [];
        let params = {
            url: url,
            method: "get",
        };
        self.setState({isLoading: true});
        return request(params)
            .then(function (response) {
                let listPriceMbs=response.data;
                for(let i=0;i<listPriceMbs.length;i++){
                    listPriceMbs[i]["startDate"] = moment(listPriceMbs[i]["startDate"]).format("YYYY-MM-DD");
                    listPriceMbs[i]["finishDate"] = moment(listPriceMbs[i]["finishDate"]).format("YYYY-MM-DD");
                }
                self.setState({
                    isLoading: false,
                })
                return Promise.resolve(response.data);
            }).catch(function (error) {
                showAxiosError(error);
                self.setState({ isLoading: false})
                return Promise.resolve(listPriceMbs);
            });
    }

    async fetchCustomerCntFactor() {
        let self = this;
        let url =  '/list-price/customer-factor/customer/'+this.props.customer.recordId;
        let customerCntFactor = [];
        let params = {
            url: url,
            method: "get",
        };
        self.setState({isLoading: true});
        return request(params)
            .then(function (response) {
                let customerCntFactor=response.data;
                for(let i=0;i<customerCntFactor.length;i++){
                    customerCntFactor[i]["startDate"] = moment(customerCntFactor[i]["startDate"]).format("YYYY-MM-DD");
                    customerCntFactor[i]["finishDate"] = moment(customerCntFactor[i]["finishDate"]).format("YYYY-MM-DD");
                }
                self.setState({
                    isLoading: false,
                })
                return Promise.resolve(response.data);
            }).catch(function (error) {
                showAxiosError(error);
                self.setState({ isLoading: false})
                return Promise.resolve(customerCntFactor);
            });
    }

    async fetchInstallationPrices() {
        let self = this;
        let customerId = this.props.customer ? this.props.customer.recordId : 0;
        let url =  `/list-price/fetchInstallationPriceList/${customerId}`;
        let installationPriceList = [];
        let defaultPrices = false;
        let params = {
            url: url,
            method: "get",
        };
        self.setState({isLoading: true});
        return request(params)
            .then(function (response) {
                installationPriceList = response.data;
                for(let i=0; i < installationPriceList.length;i++){
                    installationPriceList[i]["startDate"] = moment(installationPriceList[i]["startDate"]).format("YYYY-MM-DD");
                    installationPriceList[i]["expireDate"] = moment(installationPriceList[i]["expireDate"]).format("YYYY-MM-DD");
                }
                self.setState({
                    isLoading: false
                })
                return Promise.resolve(response.data);
            }).catch(function (error) {
                showAxiosError(error);
                self.setState({ isLoading: false})
                return Promise.resolve(installationPriceList);
            });
    }

    closeCustomerPriceListModal() {
        this.props.toggle()
    }

    fetchCreditYears() {
        let self = this;
        let url = '/list-price/expire-year/'+this.props.customer.recordId;
        let creditsYears = [];
        let params = {
            url: url,
            method: "get",
        };
        self.setState({isLoading: true});
        return request(params)
            .then(function (response) {
                self.setState({isLoading: false})
                return Promise.resolve(response.data);
            }).catch(function (error) {
                showAxiosError(error);
                self.setState({isLoading: false})
                return Promise.resolve(creditsYears);
            });
    }

    onChangePrice(e, index,key) {
        let listPrices = deepCopyObject(this.state.listPrices);
        let listPriceMbs = deepCopyObject(this.state.listPriceMbs);

        if (key === "listPrices") {
            listPrices[index]["priceCash"] = toFixedNumber(Number(e.value), 2, 10);
            if ( listPrices[index]["upperLimit"]!==null && (new Decimal(listPrices[index]["upperLimit"])).toNumber() !== 0)
                listPrices[index]["unitPrice"] = toFixedNumber(Number(e.value) / Number(listPrices[index]["upperLimit"]), 4, 10);
            else
                listPrices[index]["unitPrice"] = toFixedNumber(Number("0"), 4, 10);
        }
        else if (key === "listPriceMbs"){
            listPriceMbs[index]["priceCash"] = toFixedNumber(Number(e.value), 2, 10);
            if ( listPriceMbs[index]["upperLimit"]!==null && (new Decimal(listPriceMbs[index]["upperLimit"])).toNumber() !== 0)
                listPriceMbs[index]["unitPrice"] = toFixedNumber(Number(e.value) / Number(listPriceMbs[index]["upperLimit"]), 4, 10);
            else
                listPriceMbs[index]["unitPrice"] = toFixedNumber(Number("0"), 4, 10);
        }
        this.setState({listPrices,listPriceMbs});
    }

    onChange(e, index,key) {
        let listPrices = deepCopyObject(this.state.listPrices);
        let listPriceMbs = deepCopyObject(this.state.listPriceMbs);
        let customerCntFactor = deepCopyObject(this.state.customerCntFactor);
        let installationPriceList = deepCopyObject(this.state.installationPriceList);

        if(key==="listPrices") {

            listPrices[index][e.name] = toFixedNumber(Number(e.value), 2, 10);
            if(e.name==="factor") {listPrices=this.updateFactor(listPrices,e.value);}
        }
        else if(key==="listPriceMbs"){
            listPriceMbs[index][e.name] = toFixedNumber(Number(e.value),2,10);
            if(e.name==="factor") {listPriceMbs=this.updateFactor(listPriceMbs,e.value);}
        }
        else if(key==="customerCntFactor"){
            customerCntFactor[index][e.name] = toFixedNumber(Number(e.value),2,10);
        }
        else if(key=== "installationPriceList"){
            if (e.name === "progressRate")
                installationPriceList = this.updateProgressRate(installationPriceList, e.value);
            else
                installationPriceList[index][e.name] = toFixedNumber(Number(e.value), 2, 10);
        }

        this.setState({listPrices,listPriceMbs,customerCntFactor, installationPriceList},() =>{
            if(e.name==="upperLimit") {
                this.onChangePrice({value:this.state[key][index]["priceCash"]}, index, key);
            }
        });
    }

    onChangeNumber(e, index,key){
        let installationPriceList = deepCopyObject(this.state.installationPriceList);
        if(key === "installationPriceList"){
            installationPriceList[index][e.name] = e.value;
        }
        console.log(e, index, key)
        this.setState({installationPriceList});
    }

    onChangeCredits(e,index){
        let creditsYears = this.state.creditsYears;
        creditsYears[index].expireYear=e.target.value;
        this.setState({creditsYears});
    }

    updateFactor(arr,value){
        let arr_ = deepCopyObject(arr);
        for(let i=0;i<arr_.length;i++){
            arr_[i]["factor"] = Number(value).toFixed(2);
        }
        return arr_;
    }

    updateProgressRate(arr,value){
        let arr_ = deepCopyObject(arr);
        for(let i=0;i<arr_.length;i++){
            arr_[i]["progressRate"] = Number(value).toFixed(2);
        }
        return arr_;
    }

    handleRemove(index,key){
        let listPrices = deepCopyObject(this.state.listPrices);
        let listPriceMbs = deepCopyObject(this.state.listPriceMbs);
        let customerCntFactor = deepCopyObject(this.state.customerCntFactor);
        let installationPriceList = deepCopyObject(this.state.installationPriceList);

        if(key==="listPrices")
            listPrices.splice(index,1);
        else if(key==="listPriceMbs")
            listPriceMbs.splice(index,1);
        else if(key==="customerCntFactor")
            customerCntFactor.splice(index,1);
        else if(key === "installationPriceList")
            installationPriceList.splice(index,1);

        this.setState({listPrices,listPriceMbs,customerCntFactor, installationPriceList});
    }

    addNewLine(key){
        let listPrices = deepCopyObject(this.state.listPrices);
        let listPriceMbs = deepCopyObject(this.state.listPriceMbs);
        let customerCntFactor = deepCopyObject(this.state.customerCntFactor);
        let installationPriceList = deepCopyObject(this.state.installationPriceList);

        if(key==="listPrices"){
            listPrices.push({
                recordId:null,
                ownerCustomerId:this.props.customer.recordId,
                startDate:null,
                finishDate: null,
                lowerLimit: null,
                upperLimit:null,
                priceCash:null,
                priceInSixInstallments:null,
                priceInNineInstallments: null,
                unitPrice:0.00,
                factor:1.00,
            })
        }else if(key==="listPriceMbs") {
            listPriceMbs.push({
                recordId: null,
                ownerCustomerId: this.props.customer.recordId,
                startDate: null,
                finishDate: null,
                lowerLimit: null,
                upperLimit: null,
                priceCash: null,
                priceInSixInstallments: null,
                priceInNineInstallments: null,
                unitPrice: 0.00,
                factor: 1.00,
            })
        }else if(key==="customerCntFactor") {
            customerCntFactor.push({
                recordId:null,
                ownerCustomerId:this.props.customer.recordId,
                startDate:null,
                finishDate: null,
                lowerLimit: null,
                upperLimit:null,
                factor:0.00,
            })
        }
        else if(key==="installationPriceList") {
            installationPriceList.push({
                recordId:null,
                customerId:this.props.customer.recordId,
                connectorType:null,
                serviceType:1,
                servicePrice:0.00,
                progressRate:0,
                startDate: null,
                expireDate: null
            })
        }

        this.setState({listPrices,listPriceMbs,customerCntFactor, installationPriceList});
    }

    checkRangeOverLaps(){
        let rangeOverlapError=null;
        let listPrices = deepCopyObject(this.state.listPrices);
        let listPriceMbs = deepCopyObject(this.state.listPriceMbs);

        if(Array.isArray(listPrices)){
            for(let i=0; i<listPrices.length; i++){
                for(let j=0; j<listPrices.length; j++)
                    if(j===i)
                        continue;
                    else {
                        if ((Number(listPrices[j]["lowerLimit"]) < Number(listPrices[i]["lowerLimit"])) &&(Number(listPrices[i]["lowerLimit"]) <  Number(listPrices[j]["upperLimit"])) ){
                            rangeOverlapError = rangeOverlapError + (i + 1) + "inci satırdaki Alt Limit " + (j+ 1) + " inci satırdaki aralıklarla çakışmaktadır. Çakışmayan Aralıklar Giriniz.</br>";
                        }
                        if ((Number(listPrices[j]["lowerLimit"]) < Number(listPrices[i]["upperLimit"]))  && (Number(listPrices[i]["upperLimit"]) < Number(listPrices[j]["upperLimit"]))) {
                            rangeOverlapError = rangeOverlapError + (i + 1) + "inci satırdaki Alt Limit " + (j+ 1) + " inci satırdaki aralıklarla çakışmaktadır. Çakışmayan Aralıklar Giriniz.</br>";
                        }
                    }
            }
        }

        if(Array.isArray(listPriceMbs)){
            for(let i=0; i<listPriceMbs.length; i++){
                for(let j=0; j<listPriceMbs.length; j++)
                    if(j===i)
                        continue;
                    else {
                        if ((Number(listPriceMbs[j]["lowerLimit"]) < Number(listPriceMbs[i]["lowerLimit"])) &&(Number(listPriceMbs[i]["lowerLimit"]) <  Number(listPriceMbs[j]["upperLimit"])) ){
                            rangeOverlapError = rangeOverlapError + (i + 1) + "inci satırdaki Alt Limit " + (j+ 1) + " inci satırdaki aralıklarla çakışmaktadır. Çakışmayan Aralıklar Giriniz.</br>";
                        }
                        if ((Number(listPriceMbs[j]["lowerLimit"]) < Number(listPriceMbs[i]["upperLimit"]))  && (Number(listPriceMbs[i]["upperLimit"]) < Number(listPriceMbs[j]["upperLimit"]))) {
                            rangeOverlapError = rangeOverlapError + (i + 1) + "inci satırdaki Alt Limit " + (j+ 1) + " inci satırdaki aralıklarla çakışmaktadır. Çakışmayan Aralıklar Giriniz.</br>";
                        }
                    }
            }
        }
        return rangeOverlapError;
    }

    checkRanges(){
        let rangeError=null;
        let listPrices = deepCopyObject(this.state.listPrices);
        let listPriceMbs = deepCopyObject(this.state.listPriceMbs);

        if(Array.isArray(listPrices)){
            for(let i=0; i<listPrices.length; i++){
                if ((Number(listPrices[i]["lowerLimit"]) > Number(listPrices[i]["upperLimit"])) ){
                    rangeError = rangeError + (i + 1) + "inci satırdaki Alt Limit  aynı satırdaki Üst Limitten Büyüktür!</br>";
                }
            }
        }

        if(Array.isArray(listPriceMbs)){
            for(let i=0; i<listPriceMbs.length; i++){
                if ((Number(listPriceMbs[i]["lowerLimit"]) > Number(listPriceMbs[i]["upperLimit"])) ){
                    rangeError = rangeError + (i + 1) + "inci satırdaki Alt Limit  aynı satırdaki Üst Limitten Büyüktür!</br>";
                }
            }
        }
        return rangeError;
    }

    save(){
        let validity=this.listPriceRef.current.validateComponent();
        let validity2=this.listPriceMbRef.current.validateComponent();
        let validity3=this.customerCntFactorRef.current.validateComponent();
        let validity6 = { valid: true };
        if (showConnectorPayment(EntegratorConf.identifier)) {
            validity6 = this.installationPriceRef.current.validateComponent();
        }

        let rangeOverlapError = this.checkRangeOverLaps();
        let rangeError = this.checkRanges();
        let self = this;
        let url =  '/list-price/save-all';
        let params = {
            url: url,
            method: "post",
            data:{
                listPrices: self.state.listPrices,
                listPriceMbs: self.state.listPriceMbs,
                customerCntFactors : self.state.customerCntFactor,
                installationPrices: self.state.installationPriceList,
                customerId: self.props.customer.recordId,
                creditExpireTimeList: self.state.creditsYears
            }
        };
        if(validity.valid && validity2.valid && validity3.valid && validity6.valid && rangeOverlapError===null && rangeError==null){
            this.setState({isLoading:true});
            request(params)
                .then(function (response) {
                    self.setState({
                        isLoading: false,
                    })
                    Alert.success("Fiyat Listesi Başarıyla Kaydedildi.", {
                        position: 'top-right',
                        effect: 'stackslide',
                        timeout: 5000
                    });
                }).catch(function (error) {
                showAxiosError(error);
                self.setState({ isLoading: false})
            });
        }else{
            let message="Hatalı veya eksik alanlar var!<br>" +
                ((rangeOverlapError!==null) ? "Örtüşen 'Alt Limit' , 'Üst Limit' aralıkları var, düzeltip tekrar deneyiniz!" : "") +
                ((rangeError!==null) ? "Aynı satırdaki 'Alt Limit' değerleri, 'Üst Limit' değerlerinden küçük olmalıdır, düzeltip tekrar deneyiniz!" : "")
            showAxiosError({message : message});
        }
    }

    toggle(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({activeTab: tab});
        }
    }


    render() {
        const {listPrices} = this.state;
        const {listPriceMbs} = this.state;
        const {customerCntFactor} = this.state;
        const {installationPriceList} = this.state;

        return (
            <div>
                <Modal isOpen={this.props.isOpen} size='lg'>
                    <ModalHeader toggle={this.closeCustomerPriceListModal}>Bayi Fiyat Listesi</ModalHeader>
                    <ModalBody  style={{paddingTop: '4px'}} >
                        <Label style={{margin:"10px",color:"red",fontWeight:"bold",fontSize:"14px"}}>Müşteri TCKN/VKN : {this.props.customer && this.props.customer.vknTckn}</Label>

                        <div className="card-header-danger pl-2 pr-2">
                            <div className="nav-tabs-navigation">
                                <div className="nav-tabs-wrapper">
                                    <ul className="nav tabBackground nav-tabs" data-tabs="tabs">
                                        <li className="nav-item">
                                            <a className={"nav-link " + (this.state.activeTab === 'priceList' ? 'active' : '')}
                                               onClick={() => {
                                                   this.toggle('priceList');
                                               }}
                                               data-toggle="tab">Kontör</a>
                                        </li>
                                        <li className="nav-item">
                                            <a className={"nav-link " + (this.state.activeTab === 'priceListMb' ? 'active' : '')}
                                               onClick={() => {
                                                   this.toggle('priceListMb');
                                               }}
                                               data-toggle="tab">{defterUnitName(EntegratorConf.identifier)}</a>
                                        </li>
                                        <li className="nav-item">
                                            <a className={"nav-link " + (this.state.activeTab === 'creditsTab' ? 'active' : '')}
                                               onClick={() => {
                                                   this.toggle('creditsTab');
                                               }}
                                               data-toggle="tab">Kullanım Süresi</a>
                                        </li>
                                        <li className="nav-item">
                                            <a className={"nav-link " + (this.state.activeTab === 'customerCntFactor' ? 'active' : '')}
                                               onClick={() => {
                                                   this.toggle('customerCntFactor');
                                               }}
                                               data-toggle="tab">Hakediş Oranı</a>
                                        </li>
                                        {showConnectorPayment(EntegratorConf.identifier) &&
                                            <li className="nav-item">
                                                <a className={"nav-link " + (this.state.activeTab === 'installationPriceList' ? 'active' : '')}
                                                   onClick={() => {
                                                       this.toggle('installationPriceList');
                                                   }}
                                                   data-toggle="tab">Konnektör Ücreti</a>
                                            </li>
                                        }
                                        {this.props.customer.workType === 3 &&
                                            <li className="nav-item">
                                                <a className={"nav-link " + (this.state.activeTab === 'customerPriceList' ? 'active' : '')}
                                                   onClick={() => {
                                                       this.toggle('customerPriceList');
                                                   }}
                                                   data-toggle="tab">Toplu Kontör</a>
                                            </li>
                                        }
                                    </ul>
                                </div>
                                <hr></hr>
                                {this.state.isLoading &&
                                        <Label style={{fontSize: "10px"}}>Yükleniyor...</Label>}
                            </div>
                        </div>


                        <div className="col-sm-12">
                            <div className="tab-content">
                                <div className={"tab-pane " + (this.state.activeTab === 'priceList' ? 'active' : '')}
                                     id="priceList">
                                    {this.state.usedDefaultListPrices &&
                                        <Label style={{fontWeight: "bold", fontSize: "14px"}}>Bayi için girilen fiyat
                                            listesi bulunmamaktadır. Standart fiyatlar listelenmiştir.</Label>}
                                    {(Array.isArray(listPrices) && listPrices.length > 0) &&
                                        <CustomerPriceListItems
                                            ref={this.listPriceRef}
                                            name={"listPrices"}
                                            listPrices={listPrices}
                                            onChange={this.onChange}
                                            onChangePrice={this.onChangePrice}
                                            handleEditDates={this.handleEditDates}
                                            handleRemove={this.handleRemove}
                                            addNewLine={this.addNewLine}
                                            isLoading={this.state.isLoading}/>
                                    }
                                </div>
                                <div className={"tab-pane " + (this.state.activeTab === 'priceListMb' ? 'active' : '')}
                                     id="priceListMb">
                                    {this.state.usedDefaultListPricesMb &&
                                        <Label style={{fontWeight: "bold", fontSize: "14px"}}>Bayi için girilen fiyat
                                            listesi bulunmamaktadır. Standart fiyatlar listelenmiştir.</Label>}
                                    {(Array.isArray(listPriceMbs) && listPriceMbs.length > 0) &&
                                        <CustomerPriceListItems
                                            ref={this.listPriceMbRef}
                                            name={"listPriceMbs"}
                                            listPrices={listPriceMbs}
                                            onChange={this.onChange}
                                            onChangePrice={this.onChangePrice}
                                            handleEditDates={this.handleEditDates}
                                            handleRemove={this.handleRemove}
                                            addNewLine={this.addNewLine}
                                            isLoading={this.state.isLoading}/>
                                    }
                                </div>
                                <div
                                    className={"tab-pane " + (this.state.activeTab === 'customerCntFactor' ? 'active' : '')}
                                    id="customerCntFactor">
                                    {(Array.isArray(customerCntFactor)) &&
                                        <CustomerPriceListItems
                                            ref={this.customerCntFactorRef}
                                            name={"customerCntFactor"}
                                            listPrices={customerCntFactor}
                                            onChange={this.onChange}
                                            onChangePrice={this.onChangePrice}
                                            handleEditDates={this.handleEditDates}
                                            handleRemove={this.handleRemove}
                                            addNewLine={this.addNewLine}
                                            isLoading={this.state.isLoading}/>
                                    }
                                </div>
                                <div
                                    className={"tab-pane " + ((this.state.activeTab === 'installationPriceList' && showConnectorPayment(EntegratorConf.identifier)) ? 'active' : '')}
                                    id="installationPriceList">
                                    {this.state.usedDefaultInstallationPrices &&
                                        <Label style={{fontWeight: "bold", fontSize: "14px"}}>Bayi için girilen fiyat
                                            listesi bulunmamaktadır. Standart fiyatlar listelenmiştir.</Label>}
                                    {(Array.isArray(installationPriceList) && installationPriceList.length > 0) &&
                                        <NewCustomaryPriceListItems
                                            ref={this.installationPriceRef}
                                            name={"installationPriceList"}
                                            listPrices={installationPriceList}
                                            onChange={this.onChange}
                                            onChangePrice={this.onChangePrice}
                                            onChangeNumber={this.onChangeNumber}
                                            handleEditDates={this.handleEditDates}
                                            handleRemove={this.handleRemove}
                                            addNewLine={this.addNewLine}
                                            branchId={this.props.currentUser.activeBranchIndex}
                                            customer={this.props.customer}
                                            isLoading={this.state.isLoading}
                                            serviceTypes={this.state.serviceTypes}
                                            erpTypes={this.state.erpTypes}/>
                                    }
                                </div>
                                <div className={"tab-pane" + (this.state.activeTab === 'creditsTab' ? 'active' : '')}
                                     id="creditsTab">
                                    <div className="col-lg-6 col-sm-12">
                                        <form className="credits">
                                            <label className="col-sm-4 col-form-label">Kontör (YIL)</label>
                                            <NumberFormat
                                                name={"credits"}
                                                maxLength={1}
                                                className="form-control col-sm-7 col-lg-4"
                                                value={this.state.creditsYears[0].expireYear}
                                                index={1}
                                                isNumericString={true}
                                                displayType="input"
                                                onChange={(e) => this.onChangeCredits(e, 0)}/>
                                        </form>
                                    </div>
                                    <hr/>
                                </div>
                                <div className={"tab-pane" + (this.state.activeTab === 'creditsTab' ? 'active' : '')}
                                     id="creditsTab">
                                    <div className="col-lg-6 col-sm-12">
                                        <form className="creditsMb">
                                            <label
                                                className="col-sm-4 col-form-label">{defterUnitName(EntegratorConf.identifier)} (YIL)</label>
                                            <NumberFormat
                                                name={"creditsMb"}
                                                maxLength={1}
                                                className="form-control col-sm-7 col-lg-4"
                                                value={this.state.creditsYears[1].expireYear}
                                                index={2}
                                                isNumericString={true}
                                                displayType="input"
                                                disabled={true}
                                                onChange={(e) => this.onChangeCredits(e, 1)}/>
                                        </form>
                                    </div>
                                </div>
                                {this.props.customer.workType === 3 &&
                                    <div
                                        className={"tab-pane " + (this.state.activeTab === 'customerPriceList' ? 'active' : '')}
                                        id="customerPriceList">
                                        {(Array.isArray(listPrices) && listPrices.length > 0) &&
                                            <DistributorPriceList
                                                toggle={this.closeCustomerPriceListModal}
                                                customer={this.props.customer}
                                                currentUser={this.props.currentUser}
                                                name={"customerPriceList"}
                                                onChange={this.onChange}
                                                onChangePrice={this.onChangePrice}
                                                handleEditDates={this.handleEditDates}
                                                handleRemove={this.handleRemove}
                                                addNewLine={this.addNewLine}
                                                isLoading={this.state.isLoading}/>
                                        }
                                    </div>
                                }
                            </div>
                        </div>

                    </ModalBody>
                    <ModalFooter>
                        <button type="button" onClick={this.closeCustomerPriceListModal}
                                style={{
                                    background: ' linear-gradient(rgba(125, 125, 125, 0.57), rgb(111, 111, 111))',
                                    padding: '9px 45px 9px 20px'
                                }}
                                className="TekBtn vazgec">Kapat
                        </button>
                        <button type="button" disabled={this.state.isLoading} onClick={this.save}
                                style={{padding: '9px 45px 9px 20px'}}
                                className=" TekBtn kaydet pull-right">Kaydet
                        </button>
                    </ModalFooter>
                </Modal>

            </div>
        )
    }
}

export default CustomerPriceListModal;